import { getFirestore, collection, getDocs } from 'firebase/firestore';
import Papa from 'papaparse';
import { app } from '../config/firebase';

const SERVER_URL = 'http://localhost:3001'; // Add server URL

const db = getFirestore(app);

export async function generateVenueData() {
  try {
    // Fetch venues from Firestore
    const venuesSnapshot = await getDocs(collection(db, 'venues'));
    const venues = venuesSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // Create the venue data object
    const venueData = {
      venues: venues,
      lastUpdated: new Date().toISOString()
    };

    // Send to server to update venueData.json
    const response = await fetch(`${SERVER_URL}/api/admin/update-venue-data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(venueData)
    });

    if (!response.ok) {
      const errorData = await response.text();
      console.error('Server response:', response.status, errorData);
      throw new Error(`Failed to update venue data on server: ${response.status} ${errorData}`);
    }

    return venueData;
  } catch (error) {
    console.error('Error generating venue data:', error);
    throw error;
  }
} 